import { Link as RouterLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Layout from "./Layout";

const NotFound = () => {
  return (
    <Layout>
      <Container maxWidth="sm" sx={{ py: { xs: 6, sm: 10 }, textAlign: "center" }}>
        <Typography
          sx={{
            fontWeight: 800,
            fontSize: { xs: "3.5rem", sm: "5rem" },
            color: "primary.main",
            lineHeight: 1,
            mb: 1,
          }}
        >
          404
        </Typography>
        <Typography variant="h5" sx={{ mb: 1, fontWeight: 700 }}>
          Page not found
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          This page may have moved or no longer exists. If you followed a
          link from an email, please check it's the most recent one, or
          reach out to our HR Team.
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Button component={RouterLink} to="/" variant="contained">
            Back to home
          </Button>
        </Box>
      </Container>
    </Layout>
  );
};

export default NotFound;
